import React from "react";
import PodcastPlayer from "../components/molecules/podcast-player/PodcastPlayer";
import GridLayout from "../components/organisms/grid-layout/GridLayout";
import Layout from "../components/organisms/layout/layout";
import PodcastHeader from "../components/organisms/podcast-header/PodcastHeader";
import SEO from "../shared/seo";
import { FaHeadphones } from "react-icons/fa";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import PreviewCard, { PreviewCardProps } from "../components/molecules/PreviewCard/PreviewCard";
import Suscribe from "../components/molecules/suscribe/suscribe";
import AsideBar from "../components/organisms/aside/AsideBar";
import { shuffleArray } from "../utils/arrayUtilities";
import "./../styles/index.scss";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import { adapterSuscribe } from "../components/templates/library-components/adapters";

const podcastTemplate = (props) => {
  const episode = props.pageContext;
  const compClass = "m-component-layout";
  
  return (
    <Layout hideHeaderDesktop={false} hideHeaderMobile={false}>
      <SEO
        title={ props.pageContext.name || "Podcast" } 
        // description={ metaDescription && metaDescription.json.content[0].content[0].value } 
        // image={
        //   Componentes &&
        //   Componentes[0].referenciaPlantillaContenido[0]
        //     .imagenPrincipal[0].file.url
        // }
        lang="es"
      />
      <PodcastHeader
        title={episode.name}
        text={
          episode.description.split(" --- ")[0] ||
          "Escucha este genial podcast de Revista Comfama."
        }
        imgUrl={episode.images[0]?.url}
        id={episode.id}
      />
      <div className={`${compClass}__player`}>
        <PodcastPlayer id={episode.id} height={152} />
      </div>
      <GridLayout columns="2fr 1fr" gap="1.5rem">
        <div>
          {shuffleArray(episode.otherEpisodes)
            .slice(0, 5)
            .map((element, i) => {
              let process: PreviewCardProps = {
                description:
                  element.description.split(" --- ")[0] ||
                  "Escucha este genial podcast de Revista Comfama.",
                imageUrl: element.images[1].url,
                leftSub: "Podcast",
                link: `/${element.slug}`,
                rightSub: dateToRelativeFormat(element.release_date),
                title: element.name,
                icon: <FaHeadphones />
              };
              return <PreviewCard {...process} key={i} />;
            })}
        </div>
        <AsideBar />
      </GridLayout>
      <Suscribe {...adapterSuscribe()} />
      <Disclaimer />
    </Layout>
  );
};

export default podcastTemplate;
